import type { HomePage } from '../model/HomePage';

export const BusinessAnalyst: HomePage = {
    name: 'BusinessAnalyst',
    widgets: [ 'RecommendationTemplates', 'Automations', 'Runs' ],
    featureFlag: 'HomePage-BusinessAnalyst',
    persona: 'BUSINESS_ANALYST',
};
